import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config";

export default function Payment() {
    const url = config.baseUrl;

    const [payment, setpayment] = useState([]);
    const [tab, setTab] = useState("details");
    const [editMode, setEditMode] = useState(false);

    // Get payment ID from URL
    const paymentId = window.location.pathname.split("/").pop();

    // Fetch payment data
    useEffect(() => {
        axios
            .get(`${url}/payments/${paymentId}`)
            .then((response) => setpayment(response.data))
            .catch((error) => console.error(error));
    }, [paymentId]);

    // Handle form input changes
    const handleInputChange = (e) => {
        setEditMode(true);
        const { name, value } = e.target;
        setpayment((prevpayment) => ({
            ...prevpayment,
            [name]: value,
        }));
    };

    const handleUpdate = () => {
        setEditMode(!editMode);

        console.log("Send a PUT request to update payment details");
    };

    // Handle form submission
    const handleFormSubmit = (e) => {
        e.preventDefault();
        axios
            .put(`${url}/payment/${paymentId}`, payment)
            .then((response) => {
                setEditMode(false);
                alert("payment details updated successfully!");
            })
            .catch((error) => console.error(error));
    };

    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 rounded">
                <div className="rounded-t mb-0 px-4 py-3 bpayment-0 bg-white min-h-screen">
                    <div className="flex flex-wrap items-center">
                        <div className="relative w-full px-4 max-w-full flex-grow flex-1 flex justify-between">
                            <h3 className="font-semibold text-lg text-blueGray-700">
                                payment Information
                            </h3>
                            <button
                                className={`px-4 py-2 rounded ${editMode ? "btn-primary" : "btn-primary-disabled"}`}
                                onClick={handleUpdate}
                                disabled={!editMode}
                            >
                                UPDATE
                            </button>
                        </div>
                    </div>

                    {/* Tab Navigation */}
                    <div className="my-4">
                        <nav className="flex space-x-4 bpayment-b-2 pb-2 overflow-x-scroll">
                            {["details", "Payables", ].map((t) => (
                                <button
                                    key={t}
                                    className={`px-3 py-2 rounded bpayment-0 ${tab === t ? "bg-gray-200  " : ""}`}
                                    onClick={() => setTab(t)}
                                >
                                    {t.charAt(0).toUpperCase() + t.slice(1)}
                                </button>
                            ))}
                        </nav>
                    </div>

                    {/* Tab Content */}
                    <div className="block w-full overflow-x-auto">
                        {tab === "details" && (
                            <>
                                <div className="flex">
                                    <h4 className="font-bold mb-2">payment Details</h4>
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Name</span>
                                    </div>
                                    <input type="text" name="name" value={payment.name} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>
                                
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Email</span>
                                    </div>
                                    <input type="text" name="email" value={payment.email} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>

                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Phone</span>
                                    </div>
                                    <input type="text" name="phone" value={payment.phone} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>

                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Address</span>
                                    </div>
                                    <input type="text" name="address" value={payment.address} onChange={handleInputChange} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
                                </div>
                            </>
                        )}

                        {tab === "payables" && (
                            <div>
                                <h4 className="font-bold mb-2">Payment History</h4>
                                {/* Replace this with actual payment data */}
                                <ul>
                                    <li>Payment 1: $500</li>
                                    <li>Payment 2: $200</li>
                                    <li>Payment 3: $300</li>
                                </ul>
                            </div>
                        )}

                        {tab === "products" && (
                            <div>
                                <h4 className="font-bold mb-2">Products Offered</h4>
                                {/* Replace this with actual product data */}
                                <ul>
                                    <li>Product 1</li>
                                    <li>Product 2</li>
                                    <li>Product 3</li>
                                </ul>
                            </div>
                        )}

                        {tab === "payments" && (
                            <div>
                                <h4 className="font-bold mb-2">payment History</h4>
                                {/* Replace this with actual payment data */}
                                <ul>
                                    <li>payment 1</li>
                                    <li>payment 2</li>
                                    <li>payment 3</li>
                                </ul>
                            </div>
                        )}

                        {tab === "deliveries" && (
                            <div>
                                <h4 className="font-bold mb-2">Delivery Details</h4>
                                {/* Replace this with actual delivery data */}
                                <ul>
                                    <li>Delivery 1</li>
                                    <li>Delivery 2</li>
                                    <li>Delivery 3</li>
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}